export const TEMPLATE_TYPE = {
  MULTI_COUNTRY: 'MC',
  SINGLE_COUNTRY: 'SC',
  TRACKER: 'TRC',
} as const;

export type TemplateType = (typeof TEMPLATE_TYPE)[keyof typeof TEMPLATE_TYPE];

export const TEMPLATE_MESSAGES = {
  MULTI_COUNTRY_NOT_SUPPORTED:
    'Multi-country templates cannot be applied yet, support is in progress. Please select a single country template.',
  SAVED: 'Template successfully saved',
  UPDATED: 'Template successfully updated',
  MODIFICATION_NOT_ALLOWED:
    'You do not have permission to update this template. Save it as a new template instead.',
} as const;

/** Shown before overwriting the template already applied to the survey. */
export const TEMPLATE_OVERRIDE_CONFIRMATION = {
  TITLE: 'Update Template',
  MESSAGE: 'Do you want to override the current template?',
  CONFIRM_LABEL: 'Confirm',
  CANCEL_LABEL: 'No',
} as const;

export const TEMPLATE_CHANGE_CONFIRMATION = {
  TITLE: 'Apply Template',
  MESSAGE:
    'You are changing the template, do you want to delete the current survey?',
  DELETE_LABEL: 'Yes, delete the survey',
  KEEP_LABEL: 'No, keep the survey as a draft',
  CANCEL_LABEL: 'Cancel',
} as const;
